<template>
  <div>
    <span>
      <button v-on:click="saveMeeting()" style="border: none; background: none; margin-right: 5px">
        <Icon icon="material-symbols:save-outline" color="#7367f0" width="25" height="25" />
      </button>
    </span>
    

  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  components: { Icon },
  methods: {
    saveMeeting() {
      
      this.$root.$emit("guncelMutabakatList", this.params);
    },
    
  }
}
</script>